<div class="modal-header">
    <button type="button" class="close" ng-click="$close()">×</button>
  <h3 class="modal-title">Editando configurações de contagem</h3>
</div>
<div class="modal-body">
  <form class="form-horizontal" name="contagemForm">
    <div class="form-group" ng-class="{'has-error': contagemForm.comprimento.$invalid}">
      <label for="comprimento" class="control-label col-xs-3">Comprimento</label>
      <div class="col-xs-9">
        <div class="input-group">
          <input type="number" name="comprimento" id="comprimento" ng-model="$ctrl.data.comprimento" required min="0.01" class="form-control">
          <span class="input-group-addon">metros</span>
        </div>
      </div>
    </div>
    <div class="form-group" ng-class="{'has-error': contagemForm.distancia.$invalid}">
      <label for="distancia" class="control-label col-xs-3">Distância</label>
      <div class="col-xs-9">
        <div class="input-group">
          <input type="number" name="distancia" id="distancia" ng-model="$ctrl.data.distancia" required min="0.01" class="form-control">
          <span class="input-group-addon">metros</span>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-white" ng-click="$close()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.canSave()" ng-click="$ctrl.save()">
    Salvar
  </button>
</div>
